import { isBrowserNetworkError } from './is-browser-network-error';

const MODULE_FETCH_ERROR_PREFIX = 'Failed to fetch dynamically imported module: ';

export const getModuleFetchErrorAttributes = (
	error: Error,
): { networkErrorReason?: string; errorCode?: number } => {
	if (!error.message.startsWith(MODULE_FETCH_ERROR_PREFIX) || !isBrowserNetworkError(error)) {
		return {};
	}

	const attributes = { networkErrorReason: 'browser_network_error' };

	try {
		const url = error.message.slice(MODULE_FETCH_ERROR_PREFIX.length);
		const entry = performance.getEntriesByName(url, 'resource').at(-1);
		const status = entry && 'responseStatus' in entry ? entry.responseStatus : undefined;
		if (typeof status === 'number' && Number.isInteger(status) && status >= 100 && status <= 599) {
			return { ...attributes, errorCode: status };
		}
	} catch {
		// Resource timing is best effort and must not interrupt error reporting.
	}

	return attributes;
};
